import React, { Component, Fragment } from "react";
import { Tabs, Spin, Card, Row, Divider, Icon, Button, Switch, message } from "antd";
import ProjectsTab from "./components/ProjectsTab";
import AccountsTab from "./components/AccountsTab";
import LinkSetsTab from "./components/LinkSetsTabs";
import { inject, observer } from "mobx-react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import { locationPrefix } from "common/general";
import co from "co";
import styles from "./index.module.less";

const TabPane = Tabs.TabPane;

@inject("rootStore")
@observer
export default class CampaignPage extends Component {
	pauseResumeCampaign = () => {
		const {
			rootStore: { campaignStore }
		} = this.props;

		campaignStore.pauseResumeCampaign();
	}

	componentDidMount = () => {
		const {
			rootStore: { uiStore }
		} = this.props;

		co(
			function*() {
				let response = yield uiStore.checkImageCaptchaService();
				if (response != null) {
					if (response.error) {
						message.error("Captcha balance is low or captcha key is incorrect", 10)
					} else {
						if (response.useCaptcha) {
							if (response.balance == -1) {
								message.error("Captcha balance is low or captcha key is incorrect", 10);		
							} else if (response.balance < 1) {
								message.warn("Captcha balance is low", 10);
							}					
						}
					}			
				}	
				response = yield uiStore.checkGoogleCaptchaService();
				if (response != null) {
					if (response == null || response.error) {
						message.error("Google Captcha balance is low or captcha key is incorrect", 10);
					} else {
						if (response.useGoogleCaptcha) {
							if (response.balance == -1) {
								message.error("Google captcha balance is low or captcha key is incorrect", 10);
							} else if (response.balance < 1) {
								message.warn("Google captcha balance is low", 10);	
							}
						}
					}	
				}			
			}
		);
	}

	render() {
		const {
			rootStore: { campaignStore }
		} = this.props;

		const ui = campaignStore.ui;

		let spinning = ui.loadingCampaign == true;

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Campaigns",
				href: locationPrefix + "/"
			},
			{
				title: "Campaign"
			}
		];

		return (
			<Fragment>
				{ui.loadingCampaigns == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={"Campaign: " + campaignStore.campaign.name}
					>
						<Card>
							<Row>
								<span style={{paddingRight: 10}}>Campaign Scheduler Status:</span>
								<Switch checkedChildren="Active" unCheckedChildren="Inactive" checked={campaignStore.campaign.campaignStatus === "ACTIVE"} onChange={this.pauseResumeCampaign} loading={ui.changingCampaignStatus}/>
							</Row>							
						</Card>
						<Divider />
						<Card>
							<Spin spinning={spinning}>
								<Tabs animated={false}>
									<TabPane tab="Projects" key="Projects" forceRender={true}>
										<ProjectsTab />
									</TabPane>
									<TabPane tab="Accounts" key="Account" forceRender={true}>
										<AccountsTab />
									</TabPane>
									<TabPane tab="Backlinks" key="Backlinks" forceRender={true}>
										<LinkSetsTab />
									</TabPane>
								</Tabs>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}
